<template>
  <transition name="slide-fade" >
    <div class="home" style="min-height: 80vh">
      <carousel></carousel>
      <whatwedo></whatwedo>
      <whyfincor></whyfincor>
      <partnerships class="uk-visible@m"></partnerships>
      <industries></industries>
      <calltoaction></calltoaction>
      <testimonies></testimonies>


    </div>
  </transition>
</template>

<script>

import carousel from '@/components/sections/home/carousel'
import whatwedo from '@/components/sections/home/whatwedo'
import whyfincor from '@/components/sections/home/whyFincor'
import industries from '@/components/sections/home/industryServe'
import partnerships from '@/components/sections/home/partnerships'
import testimonies from '@/components/sections/home/testimonies'
import calltoaction from '@/components/sections/home/callToAction'

export default {
  name: 'home',
  metaInfo: {
    title: '  Finance & Corporate Accounting Service ',
    meta: [{
      content: 'FINCOR is an accounting firm in the Cayman Islands that offers accounting services in the private and public sector and high-profile individuals.'
    }]
  },
  components: {
    carousel,
    whatwedo,
    whyfincor,
    industries,
    partnerships,
    testimonies,
    calltoaction,

  }
}
</script>
